import { GetCurrentUserResponse } from '../../../platform/server/api/auth/get-current-user/get-current-user.types';
import { atom } from 'jotai';

export const CurrentUserAtom = atom<GetCurrentUserResponse>({});
